import React from 'react';
import { Chip } from '@mui/material';

const STATUS_COLORS = {
  COMPLETED: { backgroundColor: '#e8f5e9', color: '#2e7d32' },
  FAILED: { backgroundColor: '#ffebee', color: '#c62828' },
  SKIPPED: { backgroundColor: '#f5f5f5', color: '#757575' },
  PROCESSING: { backgroundColor: '#e3f2fd', color: '#1565c0' },
  RECEIVED: { backgroundColor: '#fff8e1', color: '#f57f17' },
  DEAD_LETTER: { backgroundColor: '#fce4ec', color: '#880e4f' },
  PARTIALLY_COMPLETED: { backgroundColor: '#fff3e0', color: '#e65100' },
};

const StatusChip = ({ status, size = 'small' }) => {
  const style = STATUS_COLORS[status] || { backgroundColor: '#f5f5f5', color: '#757575' };
  return <Chip label={status} size={size} sx={{ ...style, fontWeight: 600, fontSize: '11px' }} />;
};

export default StatusChip;
